<template>
  <main-right title="对比报告">
    <div class="pg">
      <div class="opt_l">
        <div class="head">生成条件</div>
        <div class="opt_box">
          <el-form class="trast_form" size="mini" :model="opt">
            <el-form-item class="must" label="订单编号1">
              <div class="item_ctt">
                <el-select
                  clearable
                  filterable
                  placeholder="请输入"
                  popper-class="form_pop contrast"
                  remote
                  reserve-keyword
                  size="mini"
                  v-model="opt.codes[0]"
                  :remote-method="remoteList"
                  @visible-change="visibleChange">
                  <el-option
                    v-for="o in orders"
                    :key="o.value"
                    v-html="o.label"
                    :value="o.value">
                  </el-option>
                </el-select>
                <i class="iconfont icon-biaodan-tianxie"></i>
              </div>
            </el-form-item>
            <el-form-item class="must" label="订单编号2">
              <div class="item_ctt">
                <el-select
                  filterable
                  placeholder="请输入"
                  popper-class="form_pop contrast"
                  remote
                  reserve-keyword
                  size="mini"
                  v-model="opt.codes[1]"
                  :remote-method="remoteList2"
                  @visible-change="visibleChange2">
                  <el-option
                    v-for="o in orders2"
                    :key="o.value"
                    v-html="o.label"
                    :value="o.value">
                  </el-option>
                </el-select>
                <i class="iconfont icon-biaodan-tianxie"></i>
              </div>
            </el-form-item>
          </el-form>
          <el-button class="task_btn" :disabled="disable" @click="foundPop">生成报告</el-button>
        </div>
      </div>
      <div class="result_r">
        <div class="head">生成结果</div>
        <div v-if="!tasks.length" class="empty_tip">
          <img src="@/assets/contrast_tip.png" class="t_icon"/>
          <div>左侧<span class="t_txt">填写订单编号</span>后再生成报告</div>
        </div>
        <div v-else class="list_wrapper">
          <ul
            class="task_ul"
            infinite-scroll-disabled="noMore"
            :infinite-scroll-immediate="false"
            v-infinite-scroll="nextPage">
            <li v-for="t in tasks" :key="t.key" is="div" class="task_item">
              <div>
                <p class="name">{{ t.name }}</p>
                <p class="date">{{ t.createTime }}</p>
              </div>
              <div class="btns">
                <div class="share_btn" @click="shareReport(t)">
                  <img class="lk_icon" src="../../assets/share.png" alt="share">
                  <span>分享链接</span>
                </div>
                <div class="del" @click="deleteTask(t)">
                  <i class="iconfont icon-shanchu"></i>
                  <span>删除</span>
                </div>
              </div>
            </li>
          </ul>
          <li v-if="loading" is="p" class="tip_bt">加载中...</li>
          <!-- <li v-if="noMore" is="p" class="tip_bt">没有更多了</li> -->
        </div>
      </div>
    </div>
    <BaseFixCenter
      title="新建任务"
      w="390"
      h="235"
      v-model="pop"
      @close="closePop">
      <template #default>
        <div class="pop_main">
          <el-input
            class="task_name"
            maxlength="20"
            placeholder="请输入任务名称 (不超20字)"
            v-model="taskName"
            @keyup.enter.native="confirmAction">
          </el-input>
        </div>
      </template>
      <template #footer>
        <div class="footer-button primary" @click="confirmAction">确定</div>
        <div class="footer-button" @click="closePop">取消</div>
      </template>
    </BaseFixCenter>
    <BaseFixCenter title="温馨提示" w="300" h="200" v-model="delPop" @close="closeDel">
      <template #default>
        <div class="del_main">
          <p>确定要删除“{{cur.name}}”吗？</p>
        </div>
      </template>
      <template #footer>
        <div class="footer-button primary" @click="confirmDelete">确定</div>
        <div class="footer-button" @click="closeDel">取消</div>
      </template>
    </BaseFixCenter>
  </main-right>
</template>

<script>
import moment from "moment"
import easyEncrypt from "easy-jsencrypt"
import { orderPage, attentionTask, attentionTaskPage, attentionTaskDelete } from "@/utils/api"
import { highlightKeyword, uniCopy } from "@/utils/functions"

export default {
  name: 'ContrastReport',
  data() {
    return {
      opt: {
        codes: []
      },
      orders: [],
      orders2: [],
      pop: false,
      delPop: false,
      cur: {},
      taskName: '',
      loading: false,
      pageInfo: {
        pageIndex: 1,
        pageSize: 20
      },
      total: 0,
      tasks: []
    }
  },
  computed: {
    disable() {
      return !this.opt.codes[0] || !this.opt.codes[1]
    },
    noMore() {
      return (this.tasks.length && this.tasks.length >= this.total)
    }
  },
  created() {
    this.getOrders(undefined, true)
    this.orderList(undefined, true)
    this.taskList()
  },
  methods: {
    // 远程搜索订单(通过编码查询)
    remoteList(kw) {
      this.getOrders(kw)
    },
    visibleChange(v) {
      if (v) this.getOrders()
    },
    async getOrders(code, noLoading) {
      // 只搜索新数据源(下单时间2022-08-01及以后)中【已完成】的 CPD/CPR/套餐 订单
      const param = {
        orderTypes: [6001,6002,6003],
        statuses: [4],
        pageNum: 1,
        pageSize: 40,
        createStartDate: '2022-08-01',
        createEndDate: moment().format('YYYY-MM-DD')
      }
      if (code) param.codeBlur = code
      const res = await orderPage(param, noLoading)
      if (res && res.code === 0 && res.data) {
        this.orders = (res.data.list || []).map(({ name, code: oc, status }) => {
          const scd = code ? highlightKeyword(oc, code) : oc
          return {
            label: name ? `${scd}(${name})` : scd,
            value: oc,
            status
          }
        })
      }
    },
    remoteList2(kw) {
      this.orderList(kw)
    },
    visibleChange2(v) {
      if (v) this.orderList()
    },
    async orderList(code, noLoading) {
      const param = {
        orderTypes: [6001,6002,6003],
        statuses: [4],
        pageNum: 1,
        pageSize: 40,
        createStartDate: '2022-08-01',
        createEndDate: moment().format('YYYY-MM-DD')
      }
      if (code) param.codeBlur = code
      const res = await orderPage(param, noLoading)
      if (res && res.code === 0 && res.data) {
        this.orders2 = (res.data.list || []).map(({ name, code: oc, status }) => {
          const scd = code ? highlightKeyword(oc, code) : oc
          return {
            name,
            label: name ? `${scd}(${name})` : scd,
            value: oc,
            status
          }
        })
      }
    },
    foundPop() {
      if (this.opt.codes[0] === this.opt.codes[1]) return this.$message.warning('请选择两个不同订单进行对比')
      this.pop = true
    },
    closePop () {
      this.pop = false
    },
    async confirmAction() {
      if (!this.taskName) return this.$message.warning('请输入任务名称')
      const tr = await attentionTask({ name: this.taskName, orderCodes: this.opt.codes })
      if (tr && tr.code === 0) {
        this.messageTip(tr.message || '操作成功', 1)
        this.tasks = []
        this.pageInfo.pageIndex = 1
        this.taskList()
      }
      this.taskName = ''
      this.pop = false
    },
    nextPage() {
      this.pageInfo.pageIndex++
      this.taskList()
    },
    async taskList() {
      this.loading = true
      const res = await attentionTaskPage(this.pageInfo)
      this.loading = false
      if (res && res.code === 0 && res.data) {
        const { list, total } = res.data
        const fl = (list || []).map(e => {
          e.createTime = moment(e.createTime, 'YYYY-MM-DD').format('YYYY年M月D日')
          return e
        })
        this.tasks = this.tasks.concat(fl)
        this.total = total || 0
      }
    },
    async shareReport(r) {
      const cds = r.orderCodes.join(',')
      const enk = new easyEncrypt().encrypt(cds)
      const pre = window.location.host.indexOf('kl') > -1 ? 'https://kl-adh5' : 'https://adh5'
      const link = `${pre}.yun-ti.com/contrastreport?k=${encodeURIComponent(enk)}`
      const success = await uniCopy(link)
      if (success) this.messageTip('报告链接已复制', 1)
    },
    deleteTask(t) {
      this.delPop = true
      this.cur = t
    },
    async confirmDelete() {
      const res = await attentionTaskDelete(this.cur.id)
      this.delPop = false
      this.cur = {}
      if (res && res.code === 0) {
        this.messageTip(res.message || '操作成功', 1)
        this.tasks = []
        this.pageInfo.pageIndex = 1
        this.taskList()
      }
    },
    closeDel() {
      this.cur = {}
      this.delPop = false
    }
  }
}
</script>

<style lang="scss" scoped>
.pg {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-self: flex-start;
  .head {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 65px;
    box-shadow: 0 1px 0 0 #d4d4d4;
    font-size: 18px;
    font-weight: bold;
    padding: 20px;
  }
}
.opt_l {
  width: 360px;
  height: 100%;
  box-shadow: 0 0 0 1px #d4d4d4;
  .opt_box {
    height: calc(100% - 65px);
    padding: 20px;
    ::v-deep {
      .el-form-item {
        height: 40px;
        background: #FBFBFB;
        border: 1px solid #E9E9E9;
        border-radius: 4px;
        margin-bottom: 20px;
        padding-left: 18px;
        .el-form-item__label {
          min-width: 72px;
          box-shadow: -1px 0px 0px 0px #e9e9e9 inset;
          color: #282729;
          font-weight: 600;
          line-height: 20px;
          margin-top: 9px;
          padding: 0;
          text-align: left;
        }
      }
      .el-select, .el-input {
        width: 220px;
        height: 38px;
        .el-input__inner {
          border: none;
          height: 100%;
          line-height: 38px;
          padding-right: 15px;
          padding-left: 10px;
          text-overflow: ellipsis;
          &:focus {
            border-bottom: none !important;
          }
        }
        .el-input__prefix,
        .el-input__suffix {
          display: none;
        }
      }
    }
    .item_ctt {
      position: relative;
      .icon-biaodan-tianxie {
        position: absolute;
        top: 0;
        right: 5px;
        line-height: 38px;
        color: #C0C4CC;
        font-size: 15px;
      }
    }
    .trast_form {
      height: calc(100% - 60px);
    }
    .task_btn {
      width: 320px;
      height: 40px;
      background: linear-gradient(315deg, #FF846D 0%, #FF3973 100%);
      border: none;
      border-radius: 4px;
      color: #fff;
      margin-top: 20px;
      outline: none;
      padding: 0;
      &.is-disabled {
        opacity: 0.4;
      }
    }
  }
}
.pop_main {
  width: 100%;
  height: 100%;
  background: #FBFBFB;
  padding: 40px;
  .task_name {
    width: 310px;
    height: 40px;
    background: #FFFFFF;
    ::v-deep .el-input__inner {
      border-color: #E9E9E9;
      text-align: center;
    }
    ::-webkit-input-placeholder {
      color: rgba(0, 0, 0, 0.5);
    }
  }
}
.del_main {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 10px 0;
}
.result_r {
  position: relative;
  width: calc(100% - 360px);
  .empty_tip {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #999999;
    line-height: 16px;
    text-align: center;
    .t_icon {
      width: 290px;
      height: 185px;
    }
    .t_txt {
      color: #282729;
    }
  }
  .list_wrapper {
    height: calc(100% - 65px);
    padding: 10px 0 10px 20px;
    .task_ul {
      // min-height: calc(100% - 30px);
      // max-height: calc(100% - 30px);
      height: 100%;
      margin: 0;
      overflow:auto;
      padding-right: 20px;
      .task_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: 0 1px 0 0 #e9e9e9;
        height: 87px;
        padding: 20px 20px 20px 0;
        &:not(:last-child) {
          margin-bottom: 1px;
        }
        .name {
          max-width: 390px;
          font-size: 16px;
          line-height: 22px;
        }
        .date {
          color: #999999;
          line-height: 20px;
          margin-top: 5px;
        }
        .btns {
          flex-shrink: 0;
          font-size: 12px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .lk_icon {
            width: 14px;
            height: 14px;
            margin-right: 5px;
          }
          .icon-shanchu {
            margin-top: 2px;
            margin-right: 5px;
          }
          .share_btn,
          .del {
            cursor: pointer;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-left: 40px;
          }
        }
      }
    }
    .tip_bt {
      color: #888;
      line-height: 20px;
      margin-top: 10px;
      text-align: center;
    }
  }
}
</style>

<style lang="scss">
.form_pop.contrast {
  max-width: 230px;
  .el-select-dropdown__item {
    word-break: break-all;
    white-space: pre-wrap;
    height: auto;
    line-height: 16px;
    margin-bottom: 10px;
    padding: 0 15px;
  }
}
</style>

<style lang="scss">
.zone_key_word {
  color: #FF3973;
  font-weight: 600;
}
</style>
